import { Link } from 'react-router-dom';
import WebsiteNavbar from './WebsiteNavbar';
import WebsiteFooter from './WebsiteFooter';
import './Website.css';

const REPORTS = [
  {
    year: '2024',
    title: 'NCSI National Report 2024',
    description:
      'Sector rankings and year on year movement across all indexed sectors, with trends and analysis.',
    href: 'https://drive.google.com/file/d/1S7KQ0coEeTzEsViTd-fNrJXpvVSz716m/view',
  },
  {
    year: '2023',
    title: 'NCSI National Report 2023',
    description:
      'The baseline edition that started the national conversation on customer service delivery.',
    href: 'https://drive.google.com/file/d/1363fILTmx4vR84MrjKAIoVw_Dlrocccp/view',
  },
];

const WebsiteReports = () => {
  return (
    <div className="website nx nx-refined">
      <WebsiteNavbar />

      <section className="nx-page-hero">
        <div className="nx-kicker">Reports</div>
        <h1>Download the published index.</h1>
        <p>Full national reports with sector scores, trends and analysis. Free to read and share.</p>
      </section>

      <section className="nx-page-body">
        <div className="nx-reports-grid" style={{ marginTop: 0 }}>
          {REPORTS.map((r) => (
            <div className="nx-report" key={r.year}>
              <span className="nx-report-year">{r.year}</span>
              <h3>{r.title}</h3>
              <p>{r.description}</p>
              <a
                href={r.href}
                target="_blank"
                rel="noopener noreferrer"
                className="nx-btn nx-btn-primary"
              >
                Download PDF
              </a>
            </div>
          ))}
        </div>

        <div className="nx-page-cta">
          <div>
            <h2>Want your sector in the next edition?</h2>
            <p>Submit an assessment and add your experience to the national record.</p>
          </div>
          <Link to="/survey/" className="nx-btn nx-btn-primary">Take the survey</Link>
        </div>
      </section>

      <WebsiteFooter />
    </div>
  );
};

export default WebsiteReports;
